import { InternalError } from './internal-error'

export class MaintenanceError extends InternalError {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
